import React from "react"
import { useTranslation } from "react-i18next"

import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_no-component-page.scss"

export const NoComponentPage = React.memo(() => {
  const { t } = useTranslation()
  return (
    <div id="no-component-page" className="no-component-page">
      <Icon name={IconName.CONSTRUCTION} size={IconSize.XXXL} />
      <div className="no-component-page__title">
        {t("NoComponentPage.Title")}
      </div>
      <div className="no-component-page__sub-title">
        {t("NoComponentPage.SubTitle")}
      </div>
    </div>
  )
})
